export interface UrlVariable {
  label: string;
  value: string;
}

// Variables remplacées par le back avec les infos du participant (lien de redirection, URL d'embed).
export function buildUrlVariables(t: (key: string) => string): UrlVariable[] {
  return [
    { label: `[${t('urlVariable.firstName')}]`, value: '{firstName}' },
    { label: `[${t('urlVariable.lastName')}]`, value: '{lastName}' },
    { label: `[${t('urlVariable.email')}]`, value: '{email}' },
    { label: `[${t('urlVariable.phone')}]`, value: '{phoneNumber}' },
  ];
}

// Insère à la place de la sélection (ou au curseur) et renvoie la position du curseur après l'ajout.
export function insertAtSelection(
  text: string,
  selectionStart: number,
  selectionEnd: number,
  insertion: string,
): { value: string; caret: number } {
  const start = Math.max(0, Math.min(selectionStart, text.length));
  const end = Math.max(start, Math.min(selectionEnd, text.length));
  return {
    value: text.slice(0, start) + insertion + text.slice(end),
    caret: start + insertion.length,
  };
}

export interface TextSegment {
  text: string;
  isVariable: boolean;
}

// Découpe le texte autour des variables connues, pour les surligner sans toucher au texte.
export function splitTextOnVariables(text: string, variableValues: string[]): TextSegment[] {
  if (!text || variableValues.length === 0) return text ? [{ text, isVariable: false }] : [];
  const escaped = variableValues.map((value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  const known = new Set(variableValues);
  return text
    .split(new RegExp(`(${escaped.join('|')})`))
    .filter((part) => part !== '')
    .map((part) => ({ text: part, isVariable: known.has(part) }));
}
